// トップスライダーの起動 // Launch the top slider

const swiper = new Swiper(".top-swiper", {
  speed: 6000, // スライド変化時間
  loop: true,
  loopAdditionalSlides: 1,
  breakpoints: {
    320: {
      slidesPerView: 1.2,
      spaceBetween: 5,
    },
    569: {
      slidesPerView: 1.5,
      spaceBetween: 10,
    },
    769: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
  },
  autoplay: {
    delay: 0, //　スライダー表示時間
    disableOnInteraction: false,
  },
});

const swiperText = new Swiper(".js-slideText", {
  speed: 30000, 
  loop: true,
  slidesPerView: 1,
  loopAdditionalSlides: 1,
  spaceBetween: 100,
  centeredSlides: true,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
});

const swiperCompany = new Swiper(".js-companySlide", {
  loop: true, 
  slidesPerView: "auto",
  centeredSlides: true,
  speed: 12000, 
  allowTouchMove: false, 
  autoplay: {
    delay: 0,
  },
});